<ion-content>
  <div class="upgrade-feature-banner" *ngIf="!featureEnabled">
    <div class="constrained-content flex-space-between" style="align-items: center">
      Upgrade to track Microsoft Teams conversations
      <ion-button
        fill="outline"
        color="light"
        class="btn-small"
        [routerLink]="'/upgrade'"
        [queryParams]="{ plan: 'startup' }"
      >
        <ion-icon name="arrow-up-circle" class="padded-icon"></ion-icon>
        Upgrade account
      </ion-button>
    </div>
  </div>

  <div class="constrained-content">
    <ion-card-header *ngIf="!connection.id">
      <ion-input
        [(ngModel)]="connection.name"
        class="input-field big-title-input"
        placeholder="Name your inbox (ex: 'Microsoft Teams')"
        autocapitalize="sentences"
      >
      </ion-input>
    </ion-card-header>

    <ion-list>
      <ion-item>
        <h3 class="list-header">Settings</h3>
      </ion-item>
      <ion-item>
        <ion-label>Enabled: </ion-label>
        <label class="switch" slot="end">
          <input type="checkbox" [(ngModel)]="connection.enabled" />
          <span class="slider"></span>
        </label>
      </ion-item>
      <ion-item>
        <ion-label>Post to Slack channel: </ion-label>
        <div slot="end">
          <app-channel-selector
            [channel]="connection.slackChannel"
            (channelDidChange)="onConnectionChannelChanged($event)"
            [defaultInternalOnly]="true"
          ></app-channel-selector>
        </div>
      </ion-item>
      <ion-item>
        <ion-label>Teams channels to track: </ion-label>
        <ion-label slot="end">
          <div style="display: flex; height: 100%; align-items: center; margin: 5px">
            <div
              class="round-pill-tab round-pill-tab-right"
              [ngClass]="{
                'round-pill-tab-active': !connection.channelAllowlistEnabled
              }"
              (click)="connection.channelAllowlistEnabled = false"
              style="flex-grow: 1"
            >
              Listen to all channels
            </div>
            <div
              class="round-pill-tab round-pill-tab-left"
              [ngClass]="{
                'round-pill-tab-active': connection.channelAllowlistEnabled
              }"
              (click)="connection.channelAllowlistEnabled = true"
              style="flex-grow: 1"
            >
              Restrict to specific channels
            </div>
          </div>
        </ion-label>
      </ion-item>
      <ion-list *ngIf="connection.channelAllowlistEnabled">
        <ion-item>
          <h3 class="list-header">Teams Channel Allowlist</h3>
        </ion-item>
        <ion-item *ngFor="let entry of connection.channelAllowlist; let j = index">
          {{ entry }}
          <ion-button slot="end" (click)="removeFromAllowlist(j)" color="light">Remove</ion-button>
        </ion-item>
        <ion-item>
          <ion-input placeholder="Enter Team name..." [(ngModel)]="newAllowlistTeam"></ion-input>
          <ion-input placeholder="Enter Channel name..." [(ngModel)]="newAllowlistChannel"></ion-input>
          <ion-button (click)="addToAllowlist()">Add</ion-button>
        </ion-item>
      </ion-list>
    </ion-list>
    <ion-card-title class="card-title">
      <h3 class="list-header">Connected Teams Users</h3>
      <p class="subtitle">Replies sent back to Microsoft Teams will be sent from the user you select here.</p>
    </ion-card-title>
    <ion-list>
      <ion-item *ngFor="let user of connectedUsers; trackBy: trackById">
        {{ user.name }}
      </ion-item>
      <ion-item>
        <ion-button fill="outline" (click)="addConnectedUser()">
          <ion-icon name="add-outline" class="padded-icon"></ion-icon>
          Connect
        </ion-button>
      </ion-item>
    </ion-list>

    <ion-card-title class="card-title">
      <h3 class="list-header">SLA</h3>
    </ion-card-title>
    <app-support-steps [initialSupportSteps]="connection.supportSteps" (didChange)="supportStepsDidChange($event)">
    </app-support-steps>

    <ion-card-title class="card-title flex-space-between" style="align-items: center">
      <h3 style="margin-bottom: 18px" class="list-header">Autoresponder</h3>
    </ion-card-title>

    <app-autoresponder
      [isDefault]="false"
      [initialAutoresponder]="connection.autoresponder"
      (autoresponderDidChange)="autoresponderDidChange($event)"
    ></app-autoresponder>
  </div>
</ion-content>

<ion-footer>
  <div class="flex-space-between" style="padding: 18px">
    <div class="flexed-align-center">
      <ion-button
        fill="clear"
        color="dark"
        (click)="selectProject()"
        class="button-dark-border"
        *ngIf="!connection?.id && !hideProject"
      >
        <ion-icon
          [name]="project?.name ? 'folder-open' : 'folder-open-outline'"
          class="padded-icon button-icon"
        ></ion-icon>
        {{ project?.name ? project.name : project?.id ?? 'Select a project...' }}
        <ion-icon name="chevron-down-outline" class="icon-padded-left button-icon"></ion-icon>
      </ion-button>
      <ion-button color="success" (click)="save()" class="save-button" [disabled]="!featureEnabled || isLoading">
        {{ connection.id ? 'Save changes' : 'Connect' }}
      </ion-button>
    </div>
    <div class="flexed-align-center">
      <ion-button fill="clear" (click)="dismiss()"> Cancel </ion-button>
      <ion-button color="danger" fill="clear" (click)="delete()" *ngIf="connection.id">Delete</ion-button>
    </div>
  </div>
</ion-footer>
